import { keyFromSelector, type i18n, type ResourceNamespaceMap, type SelectorKey } from "i18next"

export interface LocalizedMessage<
  TNamespace extends keyof ResourceNamespaceMap & string = keyof ResourceNamespaceMap & string,
> {
  readonly kind: "localized-message"
  readonly namespace: TNamespace
  readonly key: SelectorKey
  readonly values: Readonly<Record<string, unknown>>
}

/** Store this in persistent UI metadata instead of storing a translated string. */
export function message<TNamespace extends keyof ResourceNamespaceMap & string>(
  namespace: TNamespace,
  selector: (catalog: Parameters<Parameters<typeof keyFromSelector<TNamespace>>[0]>[0]) => string,
  values: Readonly<Record<string, unknown>> = {}
): LocalizedMessage<TNamespace> {
  return Object.freeze({
    kind: "localized-message",
    namespace,
    key: keyFromSelector(selector, { ns: namespace }),
    values: Object.freeze({ ...values }),
  })
}

/** Literal/server-authored strings remain literal. Only explicit references are translated. */
export function resolveLocalizedMessage(instance: i18n, value: string | LocalizedMessage): string {
  if (typeof value === "string") return value
  return instance.t(value.key, {
    ns: value.namespace,
    replace: value.values,
    count: typeof value.values.count === "number" ? value.values.count : undefined,
    returnObjects: false,
  })
}
